import React, { createContext, useEffect, useState, useContext } from 'react';
import { createInstance as createI18nInstance } from 'i18next';
import { LanguageCode, TranslateProvider } from "./Translate";
import { jsx as ___EmotionJSX } from "@emotion/react";
var TRANSLATION_NAMESPACE_KEY = 'translations';
var I18nDictionaryContext = /*#__PURE__*/createContext({});
function I18nDictionaryProvider(_ref) {
  var {
    children,
    dictionary
  } = _ref;
  return ___EmotionJSX(I18nDictionaryContext.Provider, {
    value: dictionary
  }, children);
}
function withI18NextTranslate(Component, dictionary, language) {
  if (language === void 0) {
    language = LanguageCode.EN;
  }
  var WrappedTranslateComponent = props => {
    var [i18nInstance] = useState(() => createI18nInstance());
    var [isInitializing, setIsInitializing] = useState(true);
    var selectedDictionary = dictionary || useContext(I18nDictionaryContext);
    useEffect(() => {
      var initParams = {
        lng: language,
        ns: TRANSLATION_NAMESPACE_KEY,
        resources: {
          [language]: {
            [TRANSLATION_NAMESPACE_KEY]: selectedDictionary
          }
        }
      };
      i18nInstance.init(initParams);
    }, []);
    useEffect(() => {
      setIsInitializing(!i18nInstance.isInitialized);
    }, [i18nInstance.isInitialized]);
    return isInitializing ? null : ___EmotionJSX(TranslateProvider, {
      translate: i18nInstance.t
    }, ___EmotionJSX(Component, props));
  };
  var name = Component.displayName || Component.name;
  WrappedTranslateComponent.displayName = "withI18NextTranslate" + name;
  return WrappedTranslateComponent;
}
export { I18nDictionaryProvider, withI18NextTranslate };